import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import Toastify from 'toastify-js';
import Swal from "sweetalert2";

const PendidikPembelajaran = () => {
    const [data, setData] = useState([]); // State untuk menyimpan daftar kelas
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        pembelajaran_id: "",
        rombongan_belajar_id: "",
        mata_pelajaran_id: "",
        nama_mapel: "",
        nama_rombel: ""

    }); // State untuk menyimpan daftar kelas
    const [isEditing, setIsEditing] = useState(false);
    const fetchKelas = useCallback(async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/getpembelajaran`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch kelas");
            }

            const data = await response.json();
            console.log(data);
            setData(data.data);
        } catch (error) {
            setError(error.message || 'Something went wrong');
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "rombongan_belajar_id") {
            console.log(value)
            const selectedRombel = data?.rombel?.find((r) => String(r.rombel_id) === String(value));
            console.log(data?.rombel)
            console.log(selectedRombel)
            setFormData({
                ...formData,
                rombongan_belajar_id: value,
                nama_rombel: selectedRombel ? selectedRombel.nama_rombel : "",
            });
        } else if (name === "mata_pelajaran_id") {
            const selectedMapel = data?.mapel?.find((m) => String(m.id_mapel) === String(value));
            setFormData({
                ...formData,
                mata_pelajaran_id: value,
                nama_mapel: selectedMapel ? selectedMapel.nama_mapel : "",
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
        console.log(formData)
    };
    const handleSubmit = async (e) => {


        e.preventDefault();
        console.log(formData)

        try {

            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/inputpembelajaran`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                setError("Gagal menyimpan data");
            }
            const result = await response.json();
            console.log(result.message)

            Toastify({
                text: result.message,
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "#4CAF50",
            }).showToast();
            fetchKelas();
            setError('');

        } catch (error) {
            Toastify({
                text: error.response?.data?.message + error,
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "red",
            }).showToast();
            setError(error.response?.data?.message + error || 'Something went wrong');
        }

    };
    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(prevState => {
            const newState = { ...prevState, ...ujian };
            console.log("Updated formData:", newState); // Ini akan mencetak nilai terbaru
            return newState;
        });
        console.log(formData)
    };
    const handleNew = () => {
        setIsEditing(false);
        setFormData({
            pembelajaran_id: "",
            rombongan_belajar_id: "",
            mata_pelajaran_id: "",
            nama_mapel: "",
            nama_rombel: ""
        });
    };


    const hapusData = async (id) => {
        if (!id) {
            alert("ID pembelajaran tidak valid.");
            return;
        }
    
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Soal yang dihapus tidak bisa dikembalikan!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/hapuspembelajaran`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                        },
                        body: JSON.stringify({id:id}),
                    });
        
                    if (!response.ok) {
                        Swal.fire("Error!", 'Gagal Menghapus Data', "error");
                    }
                    const result = await response.json();
                    console.log(result.message)
        
                    Swal.fire("Terhapus!", "Soal berhasil dihapus.", "success");
    
                    fetchKelas();
                    setError('');
                    window.location.reload();
                } catch (error) {
                    Toastify({
                        text: error.response?.data?.message + error,
                        duration: 3000,
                        close: true,
                        gravity: "top",
                        position: "right",
                        backgroundColor: "red",
                    }).showToast();
                    Swal.fire("Error!", error.response?.data?.message + error || 'Something went wrong', "error");
                }
            }
        });
    };

    useEffect(() => {
        fetchKelas();
    }, []);
    useEffect(() => {

        if (data.length > 0) {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy();
            }

            // Inisialisasi DataTable
            $('.table').DataTable({
                "dom": "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>", // Add 'B' in the appropriate position
                "language": {
                    "search": "",
                    "lengthMenu": "_MENU_"
                },
            });
        }


    }, [data]);

    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col"><small className="text-muted">Refrensi</small><h3>Pembelajaran</h3></div>

                                        <div className='col-auto'>
                                            <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Data Baru</button></div>
                                    </div>
                                    <hr />
                                    <table className="table table-hover datatable-table">
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                                <th scope="col">Mapel</th>
                                                <th scope="col">Kelas</th>
                                                <th width="50"><center>Jumlah PD</center></th>
                                                <th width="50"><center>Action</center></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.pembelajaran?.map((item, index) => (
                                                <tr key={'pml' + index}>
                                                    <td scope="row">{index + 1}</td>
                                                    <td><b>{item.nama_mapel}</b></td>

                                                    <td><b>{item.nama_rombel}</b></td>
                                                    <td><center>{item.jumlah_pd}</center></td>
                                                    <td>
                                                        <a data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={() => handleEdit(item)} href="#" className="avtar avtar-xs mx-1 btn-link-secondary"><i className="ti ti-edit f-20"></i> </a>
                                                        <a href="#" className="avtar avtar-xs mx-1 btn-link-danger" onClick={()=>hapusData(item.pembelajaran_id)}><i className="ti ti-trash f-20"></i></a></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {/* Tampilkan error jika ada */}
                                    {error && <div className="alert alert-danger">{error}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Input/Edit */}
            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{isEditing ? "Edit Pembelajaran" : "Tambah Pembelajaran"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">


                            <div className="mb-3">
                                <label className="form-label">Mapel / Matapelajaran</label>
                                <select name='mata_pelajaran_id' className="form-select" value={formData.mata_pelajaran_id} onChange={handleChange} required>
                                    <option></option>
                                    {data?.mapel?.map((itemmapel, index) => (
                                        <option key={`mpl-${index}`} value={itemmapel.id_mapel}>{itemmapel.nama_mapel}</option>
                                    ))};
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Rombel / Kelas </label>
                                <select
                                    name="rombongan_belajar_id"
                                    className="form-select"
                                    value={formData.rombongan_belajar_id || ""}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Pilih Rombel</option>
                                    {data?.rombel?.map((itemrombel, index2) => (
                                        <option key={`rm-${index2}`} value={itemrombel.rombel_id}>
                                            {itemrombel.nama_rombel}
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type="onSubmit" className="btn btn-primary" data-bs-dismiss="modal">
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    );
};

export default PendidikPembelajaran;
